/* unplugin-vue-components disabled */import { render } from "./dict.vue?vue&type=template&id=ebb90d46&scoped=true"
import script from "./dict.vue?vue&type=script&lang=js"
export * from "./dict.vue?vue&type=script&lang=js"

import "./dict.vue?vue&type=style&index=0&id=ebb90d46&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/生产环境微信商家助手yinboshi_weixin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebb90d46"]])

export default __exports__